var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 7,
    stroke: "#BABABA",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_32471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 23C14.1435 23 12.363 22.2625 11.0503 20.9497C9.7375 19.637 9 17.8565 9 16C9 14.1435 9.7375 12.363 11.0503 11.0503C12.363 9.7375 14.1435 9 16 9C17.8565 9 19.637 9.7375 20.9497 11.0503C22.2625 12.363 23 14.1435 23 16C23 17.8565 22.2625 19.637 20.9497 20.9497C19.637 22.2625 17.8565 23 16 23ZM16 21.6C17.4852 21.6 18.9096 21.01 19.9598 19.9598C21.01 18.9096 21.6 17.4852 21.6 16C21.6 14.5148 21.01 13.0904 19.9598 12.0402C18.9096 10.99 17.4852 10.4 16 10.4C14.5148 10.4 13.0904 10.99 12.0402 12.0402C10.99 13.0904 10.4 14.5148 10.4 16C10.4 17.4852 10.99 18.9096 12.0402 19.9598C13.0904 21.01 14.5148 21.6 16 21.6Z",
    fill: "#04245C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.375 16.875H11.625V15.125H20.375V16.875Z",
    fill: "#2173FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_32471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLess);
export default __webpack_public_path__ + "static/media/icon_less.e32ed58b7988d256183fec57d41ef4bf.svg";
export { ForwardRef as ReactComponent };